import { Injectable, inject } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { ROLE_PERMISSIONS } from './role-permission.map';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private perm = inject(NgxPermissionsService);

  loadRole(role: string) {
    const permissions = ROLE_PERMISSIONS[role] ?? [];
    
    this.perm.flushPermissions();
    this.perm.addPermission(permissions);
  }

  hasPermission(permission: string): boolean {
    const all = this.perm.getPermissions();
    return !!all[permission];
  }
}
